// GJEPCRegistration.jsx
import React from "react";

export default function GJEPCRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            GJEPC Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks supports exporters in obtaining GJEPC Registration for gems and jewellery trade compliance.
          </p>
          <p className="text-gray-700">
            Complete RCMC registration through GJEPC online portal including membership application, document verification, digital signature integration, export obligation compliance, and certificate issuance for availing duty benefits and trade facilitation.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: Gems and jewellery export compliance) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/325153/pexels-photo-325153.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="GJEPC registration for gems and jewellery exporters"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for seamless GJEPC RCMC application processing and membership approval.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>IEC certificate (Import Export Code from DGFT)</li>
                <li>PAN card (company and authorized signatory)</li>
                <li>Business incorporation documents (GSTIN, MoA/AoA, board resolution)</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Specialized expertise in GJEPC RCMC registrations for diamonds, gold jewellery, gemstones, and lab-grown diamond exporters with proven duty benefit facilitation.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Gems and Jewellery Sector Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete GJEPC regulations knowledge including RCMC membership benefits, duty drawback claims, EPCG authorizations, MEIS/RODTEP schemes, Kimberley Process certification, and Surat/Mumbai/Jaipur export compliance.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Documentation Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise online application preparation, IEC/PAN/GSTIN validation, board resolution drafting, digital signature setup, export obligation documentation, bank certificate coordination, and GJEPC portal submissions ensuring instant RCMC issuance.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Service Delivery
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end service from membership application through RCMC certificate, trade fair participation facilitation, duty scrip claims, export documentation support, Kimberley Process compliance, and ongoing GJEPC regulatory advisory for jewellery exporters.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
